import { BankIcon, BuildingIcon, HashTagIcon } from '@sharedCR/coreDesignSystem/icons';

import { getConditionalArray, getValueOrDash } from 'utils/data';
import { hasPropertyChanged } from 'utils/loanApplication';
import { getFieldPendingChangeAuthors } from 'utils/pendingChangesAuthors';

const getWireToIconRowsConfig = ({ wireToInfo, pendingChangesData, fieldAuthors }) => [
  {
    id: 'companyName',
    icon: BuildingIcon,
    fieldLabel: 'Wire To Company',
    authors: getFieldPendingChangeAuthors(fieldAuthors, 'companyName'),
    value: wireToInfo.companyName,
    isModified: hasPropertyChanged(pendingChangesData?.companyName),
  },
  {
    id: 'bank',
    icon: BankIcon,
    fieldLabel: 'Bank',
    authors: getFieldPendingChangeAuthors(fieldAuthors, 'bank'),
    value: wireToInfo.bank,
    isModified: hasPropertyChanged(pendingChangesData?.bank),
  },
  {
    id: 'aba',
    icon: HashTagIcon,
    fieldLabel: 'ABA',
    authors: getFieldPendingChangeAuthors(fieldAuthors, 'closingAgentAbaNumber'),
    value: `ABA: ${wireToInfo.closingAgentABANumber}`,
    isModified: hasPropertyChanged(pendingChangesData?.closingAgentAbaNumber),
  },
  {
    id: 'fedReferenceNumber',
    icon: HashTagIcon,
    fieldLabel: 'Fed Reference #',
    authors: getFieldPendingChangeAuthors(fieldAuthors, 'fedReferenceNumber'),
    value: `Fed Reference #: ${wireToInfo.fedReferenceNumber}`,
    isModified: hasPropertyChanged(pendingChangesData?.fedReferenceNumber),
  },
];

const getFurtherCreditToIconRowsConfig = ({ fundingInfo, pendingChangesData, fieldAuthors }) => [
  {
    id: 'furtherCreditAba',
    icon: HashTagIcon,
    fieldLabel: 'Further Credit To ABA',
    authors: getFieldPendingChangeAuthors(fieldAuthors, 'furtherCreditToAbaNumber'),
    value: `ABA: ${getValueOrDash(fundingInfo?.furtherCreditToABANumber)}`,
    isModified: hasPropertyChanged(pendingChangesData?.furtherCreditToAbaNumber),
  },
  {
    id: 'furtherCreditAcct',
    icon: HashTagIcon,
    fieldLabel: 'Further Credit To Account',
    authors: getFieldPendingChangeAuthors(fieldAuthors, 'furtherCreditToAccountNumber'),
    value: `Acct: ${getValueOrDash(fundingInfo?.furtherCreditToAccountNumber)}`,
    isModified: hasPropertyChanged(pendingChangesData?.furtherCreditToAccountNumber),
  },
];

export const getIconGroupsConfig = ({
  wireToInfo,
  fundingInfo,
  pendingChangesData,
  fieldAuthors = null,
  isUnsecured = false,
}) => [
  ...getConditionalArray(!isUnsecured, () => [
    {
      id: 'wireTo',
      label: 'Wire To:',
      rows: getWireToIconRowsConfig({ wireToInfo, pendingChangesData, fieldAuthors }),
    },
    {
      id: 'furtherCreditTo',
      label: 'Further Credit To:',
      rows: getFurtherCreditToIconRowsConfig({ fundingInfo, pendingChangesData, fieldAuthors }),
    },
  ]),
];
